import React, { useEffect } from "react";
import {
  AdminContentWrapper,
  AdminHeader,
  Button,
  CustomInput,
} from "../../components";
import { Form, Formik } from "formik";
import { useAppDispatch, useAppSelector } from "../../store";
import {
  clearObjectIdUser,
  logout,
  meInfoCheck,
  objectIdLogin,
} from "../../store/slices/user";
import appConfig from "../../util/appConfig";
import { userToken } from "../../util/userToken";
import style from "./style.module.scss";
import { getActiveUsersCount } from "../../store/slices/admin";

const AdminObjectLogin = () => {
  const dispatch = useAppDispatch();

  const {
    objectIdUser,
    defaultUserObject,
    // : { hausnr, hausnrzusatz, strassebez, ortsteilbez, plz },
  } = useAppSelector((state) => state.user);

  const { activeUsersCount, userCountWithBindedItem } = useAppSelector((state) => state.admin);

  useEffect(() => {
    const token = userToken.get();

    if (token) {
      dispatch(meInfoCheck(token));
    }

    dispatch(getActiveUsersCount());
  }, []);

  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <AdminHeader pageTitle={"Objekt Login"} hasBtnGroup={false} />
      <AdminContentWrapper>
        <div>
          {objectIdUser.vorname || objectIdUser.nachname ? (
            <div>
              <div className={style.text}>
                Sie sind in das Objekt{" "}
                <strong>{defaultUserObject?.objektid}</strong> eingeloggt.
              </div>
              <div className={style.text}>
                Um sich auszuloggen oder in ein anderes Objekt einzuloggen,
                wählen Sie bitte "Ausloggen"
              </div>
              <Button
                text="Ausloggen"
                width="200"
                isOutlined
                outlineColor={appConfig.mainColor}
                textColor={appConfig.mainColor}
                type="button"
                onClick={() => {
                  dispatch(logout({ navigate: () => {} }));
                }}
              />
            </div>
          ) : (
            <Formik
              initialValues={{
                adrId: "",
              }}
              onSubmit={(val) => {
                dispatch(
                  objectIdLogin({
                    adrId: val.adrId,
                    navigate: () => {
                      window.open(
                        window.location.origin,
                        "_blank",
                        "noopener,noreferrer"
                      );
                    },
                  })
                );
              }}
            >
              {() => {
                return (
                  <Form>
                    <CustomInput label="Adress ID" name="adrId" type="text" />
                    <Button
                      text="Anmelden"
                      width="200"
                      isOutlined
                      outlineColor={appConfig.mainColor}
                      textColor={appConfig.mainColor}
                      type="submit"
                    />
                  </Form>
                );
              }}
            </Formik>
          )}
        </div>
        <div
          style={{
            marginTop: "30px",
          }}
        >
          <div
            style={{
              fontFamily: "Nunito",
              fontWeight: 500,
              fontSize: "16px",
              color: "#353b3f",
              marginBottom: "8px",
            }}
          >
            Menge registrierter Bayern IDs: {activeUsersCount}.
          </div>
          <div
            style={{
              fontFamily: "Nunito",
              fontWeight: 500,
              fontSize: "16px",
              color: "#353b3f",
              marginBottom: "8px",
            }}
          >
            Menge verknüpfter IDs: {userCountWithBindedItem}.
          </div>

        </div>
      </AdminContentWrapper>
    </div>
  );
};

export default AdminObjectLogin;
